import React from 'react';

function TabNavigation({ activeTab, setActiveTab }) {
  return (
    <div className="retailer-details-tabs">
      <button
        className={`tab-button ${activeTab === 'details' ? 'active' : ''}`}
        onClick={() => setActiveTab('details')}
      >
        Retailer Details
      </button>
      <button
        className={`tab-button ${activeTab === 'customers' ? 'active' : ''}`}
        onClick={() => setActiveTab('customers')}
      >
        Linked Customer Codes
      </button>
    </div>
  );
}

export default TabNavigation;
